import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=487e25c4&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=487e25c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e25c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/laveto/new.laveto.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487e25c4')) {
      api.createRecord('487e25c4', component.options)
    } else {
      api.reload('487e25c4', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=487e25c4&scoped=true&", function () {
      api.rerender('487e25c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "galaxy/modules/Canvas/resources/js/editor/admin/Gallery.vue"
export default component.exports